import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { actions as licenseActions } from "../../../../redux/license";
import { actions as modalActions } from "../../../../redux/modals/";
import { TextField, Button } from "@vitalsource/vstui";
import Dispatcher from "../../../../dispatcher";
import { PluralTranslation } from "../../../core/translate";
import { getFocusableElements } from "../../../../utils/dom-utils";
import DialogWithRefocus from "../../../components/dialog/DialogWithRefocus";

class RedeemCode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      maxInputs: 10,
      redeemCode: [
        {
          redeemCode: "",
          errorMessage: "",
          hasError: false,
          isValid: false
        }
      ]
    };

    this.validateCode = this.validateCode.bind(this);
    this.codeError = this.codeError.bind(this);
    this._onChange = this._onChange.bind(this);
    this._addMore = this._addMore.bind(this);
    this._renderRedeemCodeInputs = this._renderRedeemCodeInputs.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {
    const redeemCodeInputs = document.getElementById("redeem-code-list");
    if (this.state.redeemCode.length > prevState.redeemCode.length) {
      const newInput = redeemCodeInputs.lastElementChild;
      const focusableElements = getFocusableElements(newInput);
      focusableElements[focusableElements.length - 1].focus();
    }
  }

  _closeModal() {
    this.props.onClose
      ? this.props.onClose()
      : Dispatcher.emit(Dispatcher.CLOSE_MODAL);
  }

  validateCode(index) {
    const { redeemCode } = this.state;
    if (redeemCode.length > index) {
      redeemCode[index].isValid = true;
      this.setState({ redeemCode });
    }
  }

  codeError(index, empty) {
    const { redeemCode } = this.state;
    if (redeemCode.length > index) {
      redeemCode[index].hasError = true;
      if (empty) {
        redeemCode[index].errorMessage = i18n.t("redeem.empty");
      } else {
        redeemCode[index].errorMessage = i18n.t("redeem.error");
      }
      this.setState({ redeemCode });
    }
  }

  redeemButtonState = (attrValue) => {
    let redeemCodeContainer = document.querySelector('.redeem-code');
    let redeemButton = redeemCodeContainer.nextElementSibling.children[1];
    if (attrValue) {
      redeemButton.setAttribute("disabled", attrValue);
    } else { 
      redeemButton.removeAttribute("disabled");
    }
  }

  _onChange(e, index) {
    const { redeemCode } = this.state;
    redeemCode[index] = {
      redeemCode: $(e.currentTarget).val().trim(),
      hasError: false,
      errorMessage: ""
    };
    this.setState({ redeemCode });
    this.redeemButtonState(false);
  }

  redemptionResponse = (resolve, index, response) => {
    switch (response.code) {
      case 200:
        this.validateCode(index);
        resolve(response);
        break;
      default:
        this.codeError(index);
        resolve("INVALID_CODE");
        break;
    }
  };

  redeemPromises = codes => {
    return codes.map((code, index, codes) => {
      return new Promise((resolve, reject) => {
        if (code.redeemCode && !code.isValid) {
          this.props
            .redeemCode(code.redeemCode)
            .then(response => {
              this.redemptionResponse(resolve, index, response);
            })
            .catch(response => {
              this.redemptionResponse(resolve, index, response);
            });
        } else if (code.isValid) {
          resolve("ALREADY_VALIDATED");
        } else {
          this.codeError(index, true);
          resolve("EMPTY");
        }
      });
    });
  };

  redeemBookCodes = e => {
    e.preventDefault();
    Fraction.Helpers.clearStoredBookList();
    const redeemPromises = this.redeemPromises(this.state.redeemCode);
    this.redeemButtonState(true);
    Promise.all(redeemPromises).then(responses => {
      if (responses.some(response => typeof response === "object")) {
        const totalBooks = responses
          .filter(response => typeof response === "object")
          .reduce((count, response) => count + response.books.length, 0);

        if (totalBooks > 1) {
          Fraction.Helpers.toast(
            i18n.t("redeem.multi-redeem", { count: totalBooks })
          );
        } else {
          const book = responses.filter(
            response => typeof response === "object" && response.books.length
          )[0].books[0];
          if (book.kind && book.kind === "EX_ACCESS_CODE") {
            Fraction.Helpers.toast(i18n.t("redeem.single-redeem-access-code"));
          } else {
            Fraction.Helpers.toast(
              i18n.t("redeem.single-redeem", {
                title: book.title,
                url: "/#/books/" + book.isbn + "/"
              })
            );
          }
        }
        Fraction.Reporter.gaEvent("code-redeemed");
      }
      if (
        responses.every(response => response !== "INVALID_CODE") &&
        !responses.every(response => response === "EMPTY")
      ) {
        this.props.closeModal();
        this.redeemButtonState(false);
      }

      this.form && this.form.validate();
    });
  };

  _addMore(e, quantity = 1) {
    e.preventDefault();
    const newRedeem = {
      redeemCode: "",
      errorMessage: "",
      hasError: false,
      isValid: false
    };
    const numberOfInputs = this.state.redeemCode.length;
    if (numberOfInputs < this.state.maxInputs) {
      if (numberOfInputs + quantity > this.state.maxInputs) {
        quantity = this.state.maxInputs - numberOfInputs;
      }
      this.setState({
        redeemCode: this.state.redeemCode.concat(
          Array(quantity).fill(newRedeem)
        )
      });
    }
  }

  _renderRedeemCodeInputs() {
    const { redeemCode } = this.state;
    return redeemCode.map((code, index) => {
      let className = "";
      let formFieldCount = index + 1;
      if (code.isValid) {
        className = "valid-code";
      }
      return (
        <li key={`redeem-code-entry-${index}`}>
          <TextField
            autoComplete="off"
            className={className}
            disabled={code.isValid}
            label={i18n.t("redeem.code-number-of", {
              actual: formFieldCount,
              total: redeemCode.length
            })}
            onChange={e => this._onChange(e, index)}
            type="text"
            validate={() => {
              return new Promise(resolve => {
                resolve(code.errorMessage);
              });
            }}
            value={code.redeemCode}
          />
        </li>
      );
    });
  }

  render() {
    return (
      <DialogWithRefocus
        open
        formProps={{
          innerRef: x => {
            if (x && x.validate) {
              this.form = x
            }
          },
          onSubmit: this.redeemBookCodes
        }}
        primaryActionButton={{
          label: i18n.t("redeem.redeem")
        }}
        secondaryActionButton={{
          label: i18n.t("base.cancel"),
          onClick: this.props.closeModal
        }}
        onRequestClose={this.props.closeModal}
        size="small"
        rootSelector="#bookshelf"
        title={i18n.t("redeem.redeem-code")}
      >
        <div className="redeem-code">
          <ul id="redeem-code-list">{this._renderRedeemCodeInputs()}</ul>
          {this.state.redeemCode.length < this.state.maxInputs && (
            <div className="add-more">
              <Button onClick={this._addMore} naked inline>
                <PluralTranslation
                  singular="redeem.add-multiple-codes"
                  plural="redeem.add-more"
                  count={this.state.redeemCode.length}
                  amount={this.state.redeemCode.length}
                />
              </Button>
            </div>
          )}
          <p htmlFor="redeemCode">{i18n.t("redeem.redeem-description")}</p>
        </div>
      </DialogWithRefocus>
    );
  }
}

RedeemCode.propTypes = {
  redeemFunction: PropTypes.func
};

const mapDispatchToProps = dispatch => ({
  redeemCode: code => dispatch(licenseActions.redeemCode(code)),
  closeModal: () => dispatch(modalActions.closeModal())
});

export default connect(null, mapDispatchToProps)(RedeemCode);
